'use memo';

import { useAiChatContextRegistry } from '@/features/global-ai-chat/context/AiChatContextRegistry';
export function useActiveAiChatContext() {
  const {
    activeContext
  } = useAiChatContextRegistry();
  return activeContext;
}